const baseStyle = {
  container: {
    width: '100vw',
    height: '100vh',
    position: 'relative',
    overflow: 'hidden',
    bg: 'brandColors.primaryBG', // #F7F5F0
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    pt: {base: 5.5, md: 10}, // 22px mobile, 80px desktop
    pl: {base: 7.25, md: 20}, // 29px mobile, 80px desktop
    pr: {base: 5, md: 20}, // 20px mobile, 80px desktop
    zIndex: 2,
  },
  logo: {
    width: '112px',
    height: 'auto',
    color: 'white',
    sx: {
      '.no-image-background &': {
        color: 'brandColors.greyscale90',
      },
    },
  },
  helpLink: {
    color: {base: 'white', md: 'brandColors.greyscale'},
    fontSize: 'sm',
    fontWeight: '400',
    lineHeight: {base: 'normal', md: '16.8px'},
    letterSpacing: {base: '0.14px', md: '0'},
    sx: {
      '.no-image-background &': {
        color: 'brandColors.greyscale90',
      },
    },
  },
  content: {
    display: 'flex',
    flexDirection: {base: 'column', md: 'row'},
    height: '100%',
    sx: {
      '&:not(.no-image-background)::before': {
        content: '""',
        position: 'absolute',
        top: {base: '145px', md: 0},
        right: 0,
        height: {base: 12, md: 37},
        width: {base: 'full', md: '520px'},
        maxWidth: {base: 'full', md: '50%'},
        background: {base: 'linear-gradient(0deg, rgba(247, 245, 240, 0.00) 0%, rgba(247, 245, 240, 1.00) 70%, rgba(247, 245, 240, 1.00) 100%)', md: 'linear-gradient(0deg, rgba(247, 245, 240, 0.00) 0%,  rgba(247, 245, 240, 1.00) 50%,  rgba(247, 245, 240, 1.00) 100%)'},
        zIndex: 1,
      },
    },
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: {base: 'full', md: '520px'},
    maxWidth: {base: 'full', md: '50%'},
    flex: {base: '1 0 0', md: '0 0 520px'},
    px: {base: 5, md: 10, lg: 20}, // 20px mobile, 80px desktop
    pt: {base: 12, md: 37}, // 40px mobile, 148px desktop
    overflow: 'auto',
  },
  formInnerContainer: {
    display: 'flex',
    flexDirection: 'column',
    pb: 6,
    gap: 4,
  },
  backgroundImage: {
    flex: {base: '0 0 145px', md: '1 0 0'},
    height: {base: '145px', md: '100%'},
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    sx: {
      '&.no-image-background': {
        height: {base: '0', md: '100%'},
        flexBasis: 0,
        marginBottom: {base: '96px', lg: 0},
      },
      '&.no-image-background + .login-page-column-content, &.no-image-background + .reset-password-page-column-content': {
        paddingTop: {base: '0', md: '148px'},
      },
    },
  },
  footer: {
    borderTop: '1px solid',
    borderColor: 'brandColors.greyscale10',
    pt: 6,
    pb: 6,
    mt: 'auto',
    color: 'brandColors.greyscale80',
    fontSize: '13px',
    fontStyle: 'normal',
    fontWeight: 'medium',
    lineHeight: '120%', // 15.6px
  },
};

const PageAuth = {
  parts: [
    'container',
    'header',
    'logo',
    'helpLink',
    'content',
    'formContainer',
    'formInnerContainer',
    'backgroundImage',
    'footer'
  ],
  baseStyle,
};

export default PageAuth;
